export class CartBase {
    _cartData;
    constructor(cart) {
        this._cartData = cart;
    }
    // ---------- Basic getters ----------
    get orderTypeId() {
        return this._cartData.orderTypeId;
    }
    set orderTypeId(value) {
        this._cartData.orderTypeId = value;
    }
    get orderTypeSubId() {
        return this._cartData.orderTypeSubType.orderTypeSubId;
    }
    get priceGroupId() {
        return this._cartData.orderTypeSubType.priceGroupId;
    }
    get activeCouponIds() {
        return this._cartData.coupons.map(c => c.couponId);
    }
    get coupons() {
        return this._cartData.coupons;
    }
    get itemsCoupons() {
        return this._cartData.itemsCoupons;
    }
    get discount() {
        return this._cartData.discount;
    }
    get subtotal() {
        return this._cartData.subtotal;
    }
    get orderTypeCharge() {
        return this._cartData.orderTypeSubType.orderTypeCharge;
    }
    get total() {
        return this._cartData.total;
    }
    get items() {
        return this._cartData.items;
    }
    get futureDate() {
        return this._cartData.futureDate;
    }
    get futureMinute() {
        return this._cartData.futureMinute;
    }
    get fundraiserId() {
        return this._cartData.fundraiserId;
    }
    isCartValid() {
        return this.total > 0 && this._cartData.items.length > 0;
    }
    // ---------- Shared discount logic ----------
    addDiscountToCart(coupon, discountItems, discountAmount) {
        this._addDiscountAmount(discountAmount);
        this._addDiscountsToItems(discountItems);
        const couponKey = this._addCouponToCart(coupon);
        if (couponKey > 0) {
            this._addCouponToItemsCoupons(couponKey, discountItems);
        }
        if (coupon.getProperty("allowOtherCoupons")) {
            this._clearMarkedItems();
        }
        else {
            this._useMarkedItems();
        }
    }
    markAllHalves = (cartItems, itemKey) => {
        for (const oItem of cartItems) {
            if (oItem.itemKey === itemKey)
                oItem.discountedMarkedQuantity += 1;
        }
    };
}
//# sourceMappingURL=cart-base.js.map